// Event Date and Venue
export const EVENT_DATE = new Date('2026-08-29T18:00:00');
export const VENUE_NAME = "Setia City Convention Centre";
export const VENUE_ADDRESS = "No. 1, Jalan Setia Dagang AG U13/AG\nSetia Alam, Seksyen U13\n40170, Shah Alam, Selangor";
export const STORAGE_KEY = 'afiqazira_wedding_rsvps';
export const YOUR_GOOGLE_APPS_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbxx2Qf2qSmPoRQ3cLefm5jHXcjReNFiXA73ONyiC91GUOhrFYLxxMRhYsaqSX4dhmveIg/exec";

// Couple Information
export const GROOM_NAME = "Muhammad Afiq";
export const GROOM_FULL_NAME = "Muhammad Afiq bin Dato' Mohamed Yusoff";
export const BRIDE_NAME = "Nurul Azira";
export const BRIDE_FULL_NAME = "Nurul Azira binti Mohamed Iqbal";
export const GROOM_FATHER_NAME = "Dato' Mohamed Yusoff";
export const GROOM_MOTHER_NAME = "Datin Sabirah Banu";
export const BRIDE_FATHER_NAME = "Mohamed Iqbal";
export const BRIDE_MOTHER_NAME = "Aysha Jasmin";

/** One-line form (e.g. metadata); card uses stacked father / & / mother. */
export const GROOM_PARENTS = `${GROOM_FATHER_NAME} & ${GROOM_MOTHER_NAME}`;
export const BRIDE_PARENTS = `${BRIDE_FATHER_NAME} & ${BRIDE_MOTHER_NAME}`;

// Event Information
export const EVENT_NAME = "Muhammad Afiq & Nurul Azira";
export const EVENT_HASHTAG = "#AfiqAzira";
export const GREETING = "﷽";
export const INVITATION_TEXT = "request the honour of your presence at the marriage celebration of their children";
export const ORGANIZER = `${GROOM_PARENTS} together with ${BRIDE_PARENTS}`;

// Event Details
export const EVENT_DATE_DISPLAY = "29 August 2026";
export const EVENT_DAY = "Saturday";
export const EVENT_TIME = "6 PM onwards";
export const RSVP_DEADLINE = "15th August 2026";
export const RSVP_CLOSED = true;
export const WISHES_CLOSED = true;
export const DRESS_CODE = "Formal Attire";

export const CONTACTS = [
  { name: "Wedding Coordinator", phone: "+60197000756", role: "Guest Support", whatsapp: "https://wa.me/60197000756" }
];

export const ORGANIZATION_OPTIONS = [
  "Family",
  "Friends",
  "School / University",
  "Workplace",
  "Neighbourhood",
  "Others",
];

export const INVITATION_FROM_OPTIONS = [
  "Groom's Side",
  "Bride's Side",
  "Both",
];
